import {
	GET_EXPENSE_BILL_REQUEST, GET_EXPENSE_BILL_SUCCESS, GET_EXPENSE_BILL_ERROR,
	UPLOAD_EXPENSE_BILL_ATTACHMENTS_REQUEST, UPLOAD_EXPENSE_BILL_ATTACHMENTS_SUCCESS, UPLOAD_EXPENSE_BILL_ATTACHMENTS_ERROR,
	GET_ALL_EXPENSE_BILL_ATTACHMENTS_REQUEST,
	GET_ALL_EXPENSE_BILL_ATTACHMENTS_SUCCESS,
	GET_ALL_EXPENSE_BILL_ATTACHMENTS_ERROR,
	DELETE_EXPENSE_BILL_ATTACHMENTS_REQUEST,
	DELETE_EXPENSE_BILL_ATTACHMENTS_SUCCESS,
	DELETE_EXPENSE_BILL_ATTACHMENTS_ERROR,
	UPDATE_EXPENSE_BILL_ATTACHMENTS_REQUEST,
	UPDATE_EXPENSE_BILL_ATTACHMENTS_SUCCESS,
	UPDATE_EXPENSE_BILL_ATTACHMENTS_ERROR

} from "./types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";
const axios = require("axios");
export const getExpenseBill = (token, company_id, account_no) => (dispatch) => {
	dispatch({ type: GET_EXPENSE_BILL_REQUEST });
	return axios({
		method: "POST",
		url: `${BASEURL}getAll/accountExpense`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
		data: { company_id, account_no },
	})
		.then((response) => {
			return dispatch({ type: GET_EXPENSE_BILL_SUCCESS, payload: response.data });
		})
		.catch((error) => {
			return dispatch({
				type: GET_EXPENSE_BILL_ERROR,
				payload: error.response,
			});
		});
};


export const uploadExpenseBillAttachments = (token, values) => (dispatch) => {
	dispatch({ type: UPLOAD_EXPENSE_BILL_ATTACHMENTS_REQUEST });
	console.log("values", values);

	let data = new FormData();

	const fileObj = values?.attachment?.fileList?.[0]?.originFileObj;
	data.append('file', fileObj);
	data.append('vendor', values.vendor);
	data.append('due_date', moment(values.due_date).format("MM-DD-YYYY"));
	data.append('bill_amount', values.bill_amount);
	data.append('approval_amount', values.approval_amount);
	data.append("reference_no", values.reference_no ?? "");

	return axios({
		method: "POST",
		url: `${BASEURL}uploads/expenseBill/1`,
		data: data,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
			// Multipart Content-Type yahan se hata diya hai taake boundary error na aaye
		},
	})
		.then((response) => {
			return dispatch({ type: UPLOAD_EXPENSE_BILL_ATTACHMENTS_SUCCESS, payload: response.data });
		})
		.catch((error) => {
			return dispatch({
				type: UPLOAD_EXPENSE_BILL_ATTACHMENTS_ERROR,
				payload: error.response,
			});
		});
};


export const getAllExpenseBillAttachments = (token, billStatus) => (dispatch) => {
	dispatch({ type: GET_ALL_EXPENSE_BILL_ATTACHMENTS_REQUEST });
	return axios({
		method: "POST",
		url: `${BASEURL}getAll/expenseBill`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
		data: { bill_status: billStatus },
	})
		.then((response) => {
			return dispatch({ type: GET_ALL_EXPENSE_BILL_ATTACHMENTS_SUCCESS, payload: response.data });
		})
		.catch((error) => {
			return dispatch({
				type: GET_ALL_EXPENSE_BILL_ATTACHMENTS_ERROR,
				payload: error.response,
			});
		});
};



export const deleteExpenseBillAttachments = (token, id) => (dispatch) => {
	dispatch({ type: DELETE_EXPENSE_BILL_ATTACHMENTS_REQUEST });
	return axios({
		method: "DELETE",
		url: `${BASEURL}delete/expenseBill/${id}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
		// data: { company_id, account_no },
	})
		.then((response) => {
			return dispatch({ type: DELETE_EXPENSE_BILL_ATTACHMENTS_SUCCESS, payload: response.data });
		})
		.catch((error) => {
			return dispatch({
				type: DELETE_EXPENSE_BILL_ATTACHMENTS_ERROR,
				payload: error.response,
			});
		});
};

export const updateExpenseBillAttachments = (token, data) => (dispatch) => {
	dispatch({ type: UPDATE_EXPENSE_BILL_ATTACHMENTS_REQUEST });
	return axios({
		method: "PUT",
		url: `${BASEURL}update/expenseBill/${data.vendor_communication_id}`,
		headers: {
			Accept: "application/json",
			Authorization: "Bearer " + token,
		},
		data: {
			// is_active: data.is_active ? true : false,
			bill_amount: data.bill_amount,
			approval_amount: data.approval_amount,
			due_date: moment(data.due_date).format("MM-DD-YYYY"),
			reference_no: data.reference_no ?? ""
		},
	})
		.then((response) => {
			return dispatch({ type: UPDATE_EXPENSE_BILL_ATTACHMENTS_SUCCESS, payload: response.data });
		})
		.catch((error) => {
			return dispatch({
				type: UPDATE_EXPENSE_BILL_ATTACHMENTS_ERROR,
				payload: error.response,
			});
		});
};

